import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { SnackbarProvider } from 'notistack'
import "./fontawesome"; // Configuration des icônes FontAwesome
import "./index.css";
import App from "./App";

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SnackbarProvider>
      <App />
    </SnackbarProvider>
  </StrictMode>,
)
